//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

const fs = require('fs');
// const path = require('path');

const gagoShaders = [
    {
        name: 'lerc',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc3D',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc3D.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc3D.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc-3d',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc_3d.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc_3d.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc-terrain',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc-terrain.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc-overlay',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc-overlay.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc-compare',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc-compare.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'lerc-grid',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/lerc-grid.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/lerc-grid.vertex.glsl',  'utf8')
        },
    },
    {
        name: 'stencil-img',
        shader: {
            fragmentSource: fs.readFileSync(__dirname + '/gago-shaders/stencil-img.fragment.glsl',  'utf8'),
            vertexSource: fs.readFileSync(__dirname + '/gago-shaders/stencil-img.vertex.glsl',  'utf8')
        },
    },
];

module.exports.modifyShaders = function(setShader) {
    gagoShaders.forEach(({ name, shader }) => {
        setShader(name, shader);
    });
};
